import React from 'react';
import { NavLink } from 'react-router-dom'

import './index.scss'

// import { RiSunLine, RiMoonClearLine } from "react-icons/ri";


import {
  MdOutlineHome,
  MdOutlineMail,
  MdOutlineSchool,
  MdOutlineWorkOutline,
} from 'react-icons/md';

// const storageName = 'themeData'
// const data = JSON.parse(localStorage.getItem(storageName))

const Menu = ({setOpen, mobile}) => {
  
    //  const [mode, setMode] = React.useState(data.mode || 'light-theme')
     
    //  const toggleTheme = () => {
    //    if (mode === 'light-theme') {
    
    //     setMode('dark-theme')
    //      localStorage.setItem(storageName, JSON.stringify({
    //       mode: 'dark-theme'
    //     }))
       
    //    } else {
    //     setMode('light-theme')
    //     localStorage.setItem(storageName, JSON.stringify({
    //       mode: 'light-theme'
    //     }))
        
    //    }
    //  }

     
     
    //  React.useEffect(() => {
    //     const data = JSON.parse(localStorage.getItem(storageName))

    //     if (!data ) {

    //       localStorage.setItem(storageName, JSON.stringify({
    //         mode: mode
    //       }))
    //       const data2 = JSON.parse(localStorage.getItem(storageName))
    //       document.documentElement.className = data2.mode

    //     } else {
    //       document.documentElement.className = data.mode
    //     } 

    //  }, [mode])


    //  React.useEffect(() => {

    //     const data = JSON.parse(localStorage.getItem(storageName))
    //     document.documentElement.className = data.mode
    //  }, [mode])

     const items = [
       { id: 1, title: 'Home', url: '/', icon: <MdOutlineHome /> },
      //  { id: 2, title: 'About', url: '/about', icon: <PersonOutlineRoundedIcon /> },
       { id: 3, title: 'Resume', url: '/resume', icon: <MdOutlineSchool /> },
       { id: 4, title: 'Projects', url: '/projects', icon: <MdOutlineWorkOutline /> },
       { id: 5, title: 'Contact', url: '/contact', icon: <MdOutlineMail /> },
     ]

    return (
        <div className="header__menu">
          
          <div className="header__menuContainer">
            
            {/* { mode === 'light-theme' 
              ? <div className="toggleTheme" onClick={toggleTheme}><WbSunnyIcon /></div>
              : <div className="toggleTheme" onClick={toggleTheme}><WbSunnyOutlinedIcon /></div>
            } */}

          { mobile && items.map(item => (
            <div key={item.id} className="header__menuItem" onClick={() => setOpen(false)}>
                <NavLink end={item.url === '/'} to={item.url} >
                  {item.icon}
                  <span className="link-text">{item.title}</span>
                </NavLink>
            </div>
          )) }
          
          { !mobile && items.map(item => (
            <div key={item.id} className="header__menuItem">
                <NavLink end={item.url === '/'} to={item.url} >
                  {item.icon}
                  <span className="link-text">{item.title}</span>
                </NavLink>
            </div>
          )) }

          </div>
        </div>
    );
}

export default Menu;
